import React from 'react';
import { clientEmptyStateCardClass } from '../../utils/clientChromeClasses';

type IconComponent = React.ComponentType<{
  size?: number;
  className?: string;
  'aria-hidden'?: boolean | 'true';
}>;

export type ClientEmptyStateCardProps = {
  icon: IconComponent;
  title: string;
  children?: React.ReactNode;
  className?: string;
};

/** Large icon + title + optional hint — client run history / archives and firm run-history empty states. */
export function ClientEmptyStateCard({ icon: Icon, title, children, className = '' }: ClientEmptyStateCardProps) {
  return (
    <div className={`${clientEmptyStateCardClass} ${className}`.trim()}>
      <Icon className="mx-auto mb-3 text-gray-300" size={40} aria-hidden />
      <p className="text-sm text-gray-500">{title}</p>
      {children != null ? <div className="mx-auto mt-1 max-w-md text-xs text-gray-400">{children}</div> : null}
    </div>
  );
}
